import React from 'react';
import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { usePanelAccess } from '../../context/PanelAccessContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import {
  canPanelViewInterventionsCta,
  canPanelManageInterventions,
} from '../../panelAccess/panelRoleAccess';

type Tab = { to: string; label: string; can: boolean };

const PanelScenariosPage: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { hasAccessToSection, loading } = usePanelAccess();
  const location = useLocation();
  const roleId = currentUser?.roles_id ?? 0;

  if (loading || !currentUser) return null;

  const canCta    = hasAccessToSection('interventions')        || canPanelViewInterventionsCta(roleId);
  const canManage = hasAccessToSection('interventions_manage') || canPanelManageInterventions(roleId);

  const tabs: Tab[] = [
    { to: '/panel/scenarios/cta',        label: 'CTA — en cours',     can: canCta    },
    { to: '/panel/scenarios/gerer',      label: 'Gérer scénarios',    can: canManage },
    { to: '/panel/scenarios/creer',      label: 'Créer un scénario',  can: canManage },
    { to: '/panel/scenarios/categories', label: 'Catégories mission', can: canManage },
    { to: '/panel/scenarios/radio',      label: 'Radio ANTARES',      can: canManage },
  ];

  const visibleTabs = tabs.filter((t) => t.can);
  if (!visibleTabs.length) return <Navigate to="/panel/dashboard" replace />;

  const base = '/panel/scenarios';
  if (location.pathname === base || location.pathname === `${base}/`) {
    return <Navigate to={visibleTabs[0].to} replace />;
  }

  // Highlight "Gérer" when on edit sub-route
  const isEdit = location.pathname.startsWith('/panel/scenarios/edit/');

  return (
    <div className="space-y-5 pb-12">
      <div>
        <h1 className="text-lg font-bold text-white">Scénarios & CTA</h1>
        <p className="text-xs text-slate-400 mt-0.5">Suivi des interventions en cours, gestion et création de scénarios, catégories et messages radio.</p>
      </div>

      <div className="flex gap-1 border-b border-[#1e2d4d] pb-0 flex-wrap">
        {visibleTabs.map((tab) => {
          const forceActive = tab.to === '/panel/scenarios/gerer' && isEdit;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
                  isActive || forceActive
                    ? 'border-[#3d4fdb] text-white'
                    : 'border-transparent text-slate-400 hover:text-slate-200 hover:border-slate-600'
                }`
              }
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
};

export default PanelScenariosPage;
